export const FEATURE_NAME = '@zerops/zerops/feature/ready-to-deploy';
